import React, { useEffect, useContext } from 'react';

// ^ Redux
import { changeLocale } from 'layouts/Main/features/locale/localeSlice';

// ? context
import GlobalContext from 'layouts/Main/GlobalContext';

// ? Style
import { theme } from 'theme';
import styled from 'styled-components';
const StyledToggleButton = styled.a`
  .open & {
    background-color: ${theme.themePageHeaderPrimaryHover} !important;
  }
  &:hover {
    background-color: ${theme.themePageHeaderPrimaryHover} !important;
  }
`;

// ^ Plugins
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { storage, STORAGE_KEYS } from 'utils/storage';

export default function SwitchLangButton({ setIsNotificationDropdownOpen }) {

  // $ init data
  const { i18n } = useTranslation();
  const langs = [
    {
      key: 'zh-TW',
      text: '繁體中文'
    },
    {
      key: 'en',
      text: 'English'
    }
    // {
    //   key: 'zh-CN',
    //   text: '简体中文'
    // },
    // {
    //   key: 'jp',
    //   text: '日本語'
    // }
  ];

  // ? context
  const {
    dispatch,
    useSelector
  } = useContext(GlobalContext);

  // ^ Redux
  const locale = useSelector(state => state.locale);

  // - methods
  const switchLang = data => {
    i18n.changeLanguage(data);
    dispatch(changeLocale(data));
    storage.set(STORAGE_KEYS.LANG, data);
  };

  const currentLang = () => {
    const find = langs.find(lang => lang.key === locale);
    return find ? find.text : 'English';
  }

  // * hooks
  useEffect(() => {
    const storageLang = storage.get(STORAGE_KEYS.LANG);
    if (!storageLang) return;
    i18n.changeLanguage(storageLang);
    dispatch(changeLocale(storageLang));
  }, []);

  return (
    <li className="dropdown">
      <StyledToggleButton
        className="dropdown-toggle"
        data-toggle="dropdown"
        href="#"
        onClick={() => setIsNotificationDropdownOpen(false)}
      >
        <i
          className="fas fa-globe-americas"
          style={{ marginRight: 5 }}
        />
        <span className="hidden-sm hidden-xs">
          {currentLang()}
        </span>
      </StyledToggleButton>
      <ul className="dropdown-menu">
        {
          langs.map(item => (
            <li key={item.key}>
              <a
                href="#"
                onClick={() => {
                  switchLang(item.key);
                }}
              >
                {
                  locale === item.key ?
                    <FontAwesomeIcon
                      icon={locale === item.key ? 'check' : ''}
                    />
                    :
                    <svg height="16px" />
                }
                {item.text}
              </a>
            </li>
          ))
        }
      </ul>
    </li>
  );
}

SwitchLangButton.propTypes = {
  setIsNotificationDropdownOpen: PropTypes.func
};
